module.exports = __webpack_public_path__ + "369654453d868fecb05c86fda2db10f6.png";